<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}: Настройки</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow v-if="settingsText" class="pl-3 pb-3 red" />
                    <CRow v-if="settingsText" class="pl-3 pb-3 red">{{ settingsText }}</CRow>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow class="pl-3 pb-3 h3">Форма заказа</CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="12"
                                class="col-form-label">Поле для комментария</CCol>
                            <CCol class="d-flex align-items-center">
                                <template v-for="option in commentOptions">
                                    <CInputRadio
                                        :key="option.id"
                                        class="mb-0 ml-3 mr-0"
                                        inline
                                        name="comment"
                                        :value="option.id"
                                        :checked="selectedComment === option.id"
                                        @update:checked="updateCommentTime"
                                    /> {{ option.title }}
                                </template>
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 pb-3 h3">Блюдо в подарок</CRow>
                        <CRow class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Статус</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.promo_gift_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Подарочное блюдо</CCol>
                            <CCol sm="9">
                                <select v-model.number="settings.promo_gift_dish_id" class="form-control">
                                    <option :value="null">Не выбрано</option>
                                    <option
                                        v-for="dish in dishes"
                                        :key="dish.id"
                                        :value="dish.id">
                                        {{ dish.title }}
                                    </option>
                                </select>
                            </CCol>
                        </CRow>
                        <CRow class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Минимальная сумма заказа</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model.number="settings.promo_gift_min_order_sum"
                                    type="number"
                                    min="0"
                                    step="1"
                                    placeholder="Например, 1500"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Позиции в корзине</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="promoGiftDishSearch"
                                    placeholder="Поиск по названию блюда"
                                />
                                <div class="promo-gift-dishes">
                                    <div class="promo-gift-dishes__header">
                                        <span>Выбрано: {{ selectedPromoGiftDishesCount }}</span>
                                        <CButton
                                            v-if="selectedPromoGiftDishesCount"
                                            size="sm"
                                            color="light"
                                            @click="clearPromoGiftRequiredDishes">
                                            Очистить
                                        </CButton>
                                    </div>
                                    <div
                                        v-if="filteredPromoGiftDishes.length"
                                        class="promo-gift-dishes__list">
                                        <label
                                            v-for="dish in filteredPromoGiftDishes"
                                            :key="`required-${dish.id}`"
                                            class="promo-gift-dishes__item">
                                            <input
                                                type="checkbox"
                                                :checked="isPromoGiftRequiredDishSelected(dish.id)"
                                                @change="togglePromoGiftRequiredDish(dish.id)"
                                            />
                                            <span>{{ dish.title }}</span>
                                        </label>
                                    </div>
                                    <div v-else class="promo-gift-dishes__empty">Блюда не найдены</div>
                                </div>
                                <small class="form-text text-muted">Если список пуст, проверяется только минимальная сумма.</small>
                            </CCol>
                        </CRow>
                        <CRow class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Дата начала</CCol>
                            <CCol sm="3">
                                <CInput v-model="settings.promo_gift_date_start" type="date" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Дата окончания</CCol>
                            <CCol sm="3">
                                <CInput v-model="settings.promo_gift_date_finish" type="date" />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';

    export default {
        name: 'RestaurantSettings',

        components: {
            RestaurantsTabLinks,
        },

        data() {
            return {
                restaurant: {},
                dishes: [],
                settings: {
                    id: null,
                    restaurant_id: null,
                    show_comment: false,
                    show_large_comment: false,
                    promo_gift_enabled: false,
                    promo_gift_dish_id: null,
                    promo_gift_min_order_sum: null,
                    promo_gift_required_dish_ids: [],
                    promo_gift_date_start: null,
                    promo_gift_date_finish: null,
                },
                settingsText: '',
                commentOptions: [
                    { id: 1, title: 'Маленькое' },
                    { id: 2, title: 'Большое' },
                    { id: 3, title: 'Не показывать поле для комментария' },
                ],
                selectedComment: 3,
                promoGiftDishSearch: '',
            };
        },

        computed: {
            filteredPromoGiftDishes() {
                const search = this.promoGiftDishSearch.trim().toLowerCase();
                if (!search) {
                    return this.dishes;
                }
                return this.dishes.filter(dish => `${dish.title || ''}`.toLowerCase().indexOf(search) >= 0);
            },
            selectedPromoGiftDishesCount() {
                return (this.settings.promo_gift_required_dish_ids || []).length;
            },
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get(`/restaurants/${id}`)
                .then(resp => {
                    this.restaurant = resp.data;
                    this.settings.restaurant_id = resp.data.id;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get(`/restaurants/settings/${id}`)
                .then(resp => {
                    this.settings = {
                        ...this.settings,
                        ...resp.data,
                        promo_gift_required_dish_ids: Array.isArray(resp.data.promo_gift_required_dish_ids)
                            ? resp.data.promo_gift_required_dish_ids
                            : [],
                        promo_gift_date_start: this.formatDateInput(resp.data.promo_gift_date_start),
                        promo_gift_date_finish: this.formatDateInput(resp.data.promo_gift_date_finish),
                    };
                    this.getCommentCheck(this.settings);
                })
                .catch(e => {
                    console.log(e);
                    this.settingsText = 'Этот ресторан использует стандартные настройки, выберите настройки и нажмите «Сохранить» что бы активировать кастомные настройки.';
                });
            Vue.axios
                .get(`/restaurants/${id}/dishes`)
                .then(resp => {
                    this.dishes = Array.isArray(resp.data) ? resp.data : [];
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки блюд.');
                });
        },

        methods: {
            save() {
                this.settings.promo_gift_required_dish_ids = (this.settings.promo_gift_required_dish_ids || []).map(id => +id);
                this.settings.promo_gift_date_start = this.formatDateInput(this.settings.promo_gift_date_start);
                this.settings.promo_gift_date_finish = this.formatDateInput(this.settings.promo_gift_date_finish);
                if (!this.settings.promo_gift_enabled) {
                    this.settings.promo_gift_dish_id = null;
                    this.settings.promo_gift_min_order_sum = null;
                    this.settings.promo_gift_required_dish_ids = [];
                    this.settings.promo_gift_date_start = null;
                    this.settings.promo_gift_date_finish = null;
                }
                Vue.axios
                    .post(`/restaurants/settings/${this.$route.params.id}`, this.settings)
                    .then(() => this.goBack())
                    .catch(() => this.$root.$emit('showError', 'Ошибка сохранения.'));
            },
            formatDateInput(value) {
                if (!value) {
                    return null;
                }

                const date = moment(value);
                return date.isValid() ? date.format('YYYY-MM-DD') : null;
            },

            updateCommentTime(checked, obj) {
                for(let i = 0; i < this.commentOptions.length; i++) {
                    const condidate = this.commentOptions.find(option => option.id === +obj.target.value);
                    if (condidate.id === 1) {
                        this.settings.show_comment = true;
                        this.settings.show_large_comment = false;
                    } else if (condidate.id === 2) {
                        this.settings.show_large_comment = true;
                        this.settings.show_comment = false;
                    } else {
                        this.settings.show_large_comment = false;
                        this.settings.show_comment = false;
                    }
                }
            },
            isPromoGiftRequiredDishSelected(dishId) {
                return (this.settings.promo_gift_required_dish_ids || []).indexOf(+dishId) >= 0;
            },
            togglePromoGiftRequiredDish(dishId) {
                const selectedIds = this.settings.promo_gift_required_dish_ids || [];
                const normalizedDishId = +dishId;
                const index = selectedIds.indexOf(normalizedDishId);

                if (index >= 0) {
                    selectedIds.splice(index, 1);
                } else {
                    selectedIds.push(normalizedDishId);
                }

                this.settings.promo_gift_required_dish_ids = [...selectedIds];
            },
            clearPromoGiftRequiredDishes() {
                this.settings.promo_gift_required_dish_ids = [];
            },

            getCommentCheck(settings) {
                if (settings.show_comment) {
                    this.selectedComment = 1;
                } else if (settings.show_large_comment) {
                    this.selectedComment = 2;
                } else {
                    this.selectedComment = 3;
                }
            },

            goBack() {
                const path = `/restaurants/${this.$route.params.id}`;
                this.$router.push({ path });
            },
        },
    };
</script>
<style scoped>
.red {
    color: red;
}

.promo-gift-dishes {
    border: 1px solid #d8dbe0;
    border-radius: 4px;
    margin-top: -10px;
}

.promo-gift-dishes__header {
    align-items: center;
    background: #f8f9fa;
    border-bottom: 1px solid #d8dbe0;
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
}

.promo-gift-dishes__list {
    max-height: 220px;
    overflow-y: auto;
}

.promo-gift-dishes__item {
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: 8px;
    margin: 0;
    padding: 8px 12px;
}

.promo-gift-dishes__item:hover {
    background: #f8f9fa;
}

.promo-gift-dishes__empty {
    color: #6c757d;
    padding: 12px;
}
</style> 
